<lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
<div class="text-lg mb-5 font-bold">Staff Court Assignment</div>

<form [formGroup]="searchForm" class="bg-fieldset p-3 pb-2 rounded-lg shadow-sm border border-gray-200"
  (ngSubmit)="searchHandler()">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">

    <div class="w-full relative">
      <mat-label class="block mb-1 text-sm font-medium">Division</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <mat-select formControlName="division" placeholder="Select Division"
          (selectionChange)="onSearchDivisionChange()">
          <mat-option *ngFor="let div of divisionsList" [value]="div">{{ div.courtUnitTypeName }}</mat-option>
        </mat-select>
        <div matSuffix *ngIf="isDivisionsLoading" class="mr-2 flex items-center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-form-field>
    </div>

    <div class="w-full relative">
      <mat-label class="block mb-1 text-sm font-medium">Court</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <mat-select formControlName="courts" placeholder="Select Court">
          <mat-option *ngFor="let court of courtsList" [value]="court">{{ court.courtUnitTypeName }}</mat-option>
        </mat-select>
        <div matSuffix *ngIf="isCourtsLoading" class="mr-2 flex items-center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-form-field>
    </div>

    <div class="w-full relative">
      <mat-label class="block mb-1 text-sm font-medium">Staff Role</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <mat-select formControlName="staffRole" placeholder="Select Staff Role"
          (selectionChange)="onSearchStaffRoleChange()">
          <mat-option *ngFor="let role of staffRolesList" [value]="role">{{ role.roleName }}</mat-option>
        </mat-select>
        <div matSuffix *ngIf="isStaffRolesLoading" class="mr-2 flex items-center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-form-field>
    </div>

    <div class="w-full relative">
      <mat-label class="block mb-1 text-sm font-medium">Staff Name</mat-label>
      <mat-form-field class="w-full" appearance="outline">
        <mat-select formControlName="staffName" placeholder="Select Staff Name">
          <mat-option *ngFor="let staff of staffNamesList"
            [value]="staff">{{staff.prtId}}-{{staff.prtName}}</mat-option>
        </mat-select>
        <div matSuffix *ngIf="isStaffNamesLoading" class="mr-2 flex items-center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </mat-form-field>
    </div>

    <div class="flex gap-3 w-full justify-center md:col-span-2 lg:col-span-4 pt-1">
      <button type="button" mat-stroked-button color="primary" class="w-full md:w-auto min-w-[120px]"
        (click)="resetHandler()">Reset</button>
      <button type="submit" mat-flat-button color="primary" class="w-full md:w-auto min-w-[120px]">Search</button>
    </div>
  </div>
</form>

<div class="flex flex-col pb-3 w-full mt-6">
  <div class="flex-grow bg-fieldset rounded shadow-sm overflow-hidden">
    <div class="flex px-4 py-3 border-slate-400 border-b items-center bg-gray-50">
      <h2 class="text-lg font-semibold">Staff Court Assignments</h2>
    </div>

    <div class="px-0 md:px-4 py-2">
      @if(!isLoading){
      <div class="table-scroll-wrapper">
        <cdk-virtual-scroll-viewport itemSize="48" class="h-80 border w-full min-w-[800px]" maxItemsToRender="10">
          <table mat-table [dataSource]="dataSource" matSort class="case-summery-table virtual-scroll w-full">

            <ng-container matColumnDef="staffRoleName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap px-4"> Staff Role </th>
              <td mat-cell *matCellDef="let row" class="px-4"> {{row.staffRoleName}} </td>
            </ng-container>

            <ng-container matColumnDef="staffId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap px-4"> Staff ID </th>
              <td mat-cell *matCellDef="let row" class="px-4"> {{row.staffId}} </td>
            </ng-container>

            <ng-container matColumnDef="staffName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap px-4"> Staff Name </th>
              <td mat-cell *matCellDef="let row" class="px-4"> {{row.staffName}} </td>
            </ng-container>

            <ng-container matColumnDef="divisionName">
              <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap px-4 min-w-[120px]"> Division <span
                  class="text-red-500">*</span></th>
              <td mat-cell *matCellDef="let row" class="px-4">
                @if(row.editable) {
                <mat-form-field appearance="outline" class="density-compact w-[140px] mt-2">
                  <mat-select [(ngModel)]="row.divisionId" (selectionChange)="onDivisionChange(row, $event.value)"
                    placeholder="Select Division">
                    <mat-option *ngFor="let div of divisionsList" [value]="div.courtUnitTypeId">{{ div.courtUnitTypeName
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
                } @else {
                {{row.divisionName}}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="courtsName">
              <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap px-4 min-w-[120px]"> Court <span
                  class="text-red-500">*</span></th>
              <td mat-cell *matCellDef="let row" class="px-4">
                @if(row.editable) {
                <mat-form-field appearance="outline" class="density-compact w-[140px] mt-2">
                  <mat-select [(ngModel)]="row.courtsId" placeholder="Select Court">
                    <mat-option *ngFor="let court of row.rowCourtsList" [value]="court.courtUnitTypeId">{{
                      court.courtUnitTypeName }}</mat-option>
                  </mat-select>
                </mat-form-field>
                } @else {
                {{row.courtsName}}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap px-4"> Begin Date <span
                  class="text-red-500">*</span></th>
              <td mat-cell *matCellDef="let row" class="px-4">
                @if(row.editable) {
                <div class="flex items-center h-12 w-[130px]">
                  <mat-form-field appearance="outline" class="density-compact w-full mt-2">
                    <input [(ngModel)]="row.editedStartDate" matInput [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                } @else {
                {{row.startDate ? (row.startDate | date: 'mediumDate') : ''}}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap px-4"> End Date </th>
              <td mat-cell *matCellDef="let row" class="px-4">
                {{row.endDate ? (row.endDate | date: 'mediumDate') : ''}}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap px-4 text-end"> Actions </th>
              <td mat-cell *matCellDef="let row" class="px-4 text-end">
                <div class="flex space-x-2 justify-end min-w-[80px]">
                  @if(row.editedLoader) {
                  <mat-progress-bar mode="indeterminate" class="w-10"></mat-progress-bar>
                  } @else {
                  @if(row.editable) {
                  <button mat-icon-button class="action-btn save-btn"  (click)="onSave(row)">
                    <mat-icon fontIcon="check_circle"></mat-icon>
                  </button>
                  <button mat-icon-button class="action-btn cancel-btn"  (click)="row.editable = false">
                    <mat-icon fontIcon="cancel"></mat-icon>
                  </button>
                  } @else {
                  @if(isRecordEditable(row)) {
                  <button mat-icon-button class="action-btn edit-btn"  (click)="onEditToggle(row)">
                    <mat-icon fontIcon="edit"></mat-icon>
                  </button>
                  }
                  }}
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              class="hover:bg-gray-50 border-b border-gray-100"></tr>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
      } @else {
      <div class="flex justify-center items-center h-40">
        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      </div>
      }
    </div>
  </div>
</div>